module.exports = __webpack_public_path__ + "media/src/website/images/sponsors/keilberg-9360d42e510d0f4ba5221fb4aa41d85e.jpg";